import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { FilterAppliedEventSchema } from '../../schemas/filter/FilterAppliedEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { BUSINESS_VERTICAL, EVENT_CATEGORY } from '../../constants/EventHelper'

export interface FilterAppliedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  STORE_ID_SAP: string | null
  STORE_ID_DBP: string | null
  FILTER_CATEGORY: string
  FILTER_DETAIL: string
}

export class FilterAppliedEvent extends AnalyticsEvent {
  constructor(params: FilterAppliedEventParams) {
    super(FilterAppliedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export async function trackFilterAppliedEvent(
  filterAppliedParams: FilterAppliedEventParams
) {
  try {
    const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_SIX) || {}
    if (isEnabled) {
      const commonProperties = getCommonParams()
      const params: FilterAppliedEventParams = {
        ...commonProperties,
        ...filterAppliedParams,
      }
      params.BUSINESS_VERTICAL = BUSINESS_VERTICAL.GROCERY
      params.EVENT_CATEGORY = EVENT_CATEGORY.GROCERY
      params.PREVIOUS_SCREEN_SECTION = null // no need to set previous screen section for this event
      new FilterAppliedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking Filter Applied Event:', error)
  }
}
